import { v4 as uuidv4 } from "uuid";
// import { setQuotation } from "./useInputV2";
// haveCommandBar: 是否有命令栏组件，默认为false，如 AI搜索 的切换深度搜索按钮
// isShowTemplates: 是否展示模板，默认为false
// addAll: 是否添加全部选项展示，默认为false
// placeholder: 输入框提示语
// questionPrefix 发送问题时候加的前缀内容
// upperBar 该指令是否包含输入框上面的组件，组件需要自行实现
// lowerBar 该指令是否包含输入框下面的组件，组件需要自行实现
// model_type 到时候传入聊天接口的参数，（目前都是文件聊天模型需要填的参数，其他时候未填）
// isUseQuotation 是否使用引用，默认为false，为true时，会在发送消息的时候，加上useInputV2里面的文件引用
// defaultTemplate 切换到这个指令时，默认使用这个模板
/**
 * variants 变体，用于表现不同的形式，比如 联网搜索，和 deepseek r1的搜索
 *  condition: (commandId) => commandId === "R1", // 判断条件
 *  replace: (command) =>  // 替换内容
 * keepCommand 发送消息时候，仍然保持当前指令，不切换回 普通输入
 * chatOption 添加到聊天接口的参数，如
 */
/**
 *  当存在 type 时，才会在模板展示的时候，显示 type 的按钮, 参考：帮我写作
    type: "工作",
 */
const USER_WANT = {
  AISS: 1,
  联网搜索: 1,
  BWXZ: 2,
  帮我写作: 2,
  PPTG: 10,
  PPT生成: 10,
  AIHT: 3,
  AI画图: 3,
  YDZJ: 4,
  阅读总结: 4,
  XSSS: 7,
  学术搜索: 7,
  ZXFY: 5,
  在线翻译: 5,
  WYZY: 6,
  网页摘要: 6,
  JTDY: 8,
  图片分析: 8,
};

const INPUT_COMMAND = [
  {
    name: "联网搜索",
    desc: "搜索效率翻倍，并提供深入搜索模式",
    id: "AISS", // AI_Sou_Suo
    placeholder: "搜索、提问或发消息",
    haveCommandBar: true,
    user_want: USER_WANT["AISS"],
    // chatOption: {},
    variants: [
      {
        condition: (chatModleID) => chatModleID === "R1",
        replace: (command) => {
          return {
            ...command,
            keepCommand: true,
            user_want: undefined,
            chatOption: {
              use_internet: true,
            },
            id: "AISS-R1",
          };
        },
      },
    ],
  },
  {
    name: "帮我写作",
    desc: "提供写作灵感，驾驭各类题材和风格",
    // icon: "writeSvg",
    id: "BWXZ", // Write_Bang_Xie_Zuo (帮我写作)
    user_want: USER_WANT["BWXZ"],
    // 是否一进去就展示模板
    isShowTemplates: true,
    // 展示模板时候，是否添加全部选项展示
    addAll: true,
    placeholder: "输入你要撰写的主题",
    children: [
      {
        type: "改写和回复",
        children: [
          {
            name: "文本润色",
            id: "RS",
            img: "/static/images/index/article-2.png",
            children: [
              "帮我对以下内容进行润色：",
              {
                type: "text",
                placeholder: "[这里输入要优化的内容]",
              },
            ],
          },
          {
            name: "文本校对",
            id: "JD",
            img: "/static/images/index/article-2.png",
            children: [
              "帮我对以下内容进行校对并修正：",
              {
                type: "text",
                placeholder: "[这里输入要优化的内容]",
              },
            ],
          },
          {
            name: "调整语气",
            id: "TZYQ",
            img: "/static/images/index/article-2.png",
            children: [
              "帮我将以下内容的语气调整为",
              {
                type: "radio",
                placeholder: "[语气]",
                checkList: [
                  {
                    label: "正式的",
                    value: "正式的",
                  },
                  {
                    label: "随意的",
                    value: "随意的",
                  },
                  {
                    label: "专业的",
                    value: "专业的",
                  },
                  {
                    label: "热情的",
                    value: "热情的",
                  },
                  {
                    label: "有信息量的",
                    value: "有信息量的",
                  },
                  {
                    label: "有趣的",
                    value: "有趣的",
                  },
                ],
              },
              ":",
              {
                type: "text",
                placeholder: "[这里输入要优化的内容]",
              },
            ],
          },
          {
            name: "回复「评论」",
            id: "HFPL",
            img: "/static/images/index/article-2.png",
            children: [
              "帮我回复下面提供的“评论”内容：",
              {
                type: "text",
                placeholder: "[这里输入评论内容]",
              },
            ],
          },
          {
            name: "回复「消息」",
            id: "HFXX",
            img: "/static/images/index/article-2.png",
            children: [
              "帮我回复下面提供的“消息”内容：",
              {
                type: "text",
                placeholder: "[这里输入消息内容]",
              },
            ],
          },
          {
            name: "回复「邮件」",
            id: "HFYJ",
            img: "/static/images/index/article-2.png",
            children: [
              "帮我回复下面提供的“邮件”内容：",
              {
                type: "text",
                placeholder: "[这里输入邮件内容]",
              },
            ],
          },
        ],
      },
      {
        type: "工作",
        children: [
          {
            name: "文章",
            id: "WZ", // Wen_Zhang
            img: "/static/images/index/article-1.png",
            children: [
              "帮我写一篇关于",
              {
                type: "text",
                placeholder: "[主题]",
              },
              "的",
              {
                type: "text",
                placeholder: "[平台：如公众号、知乎、头条]",
              },
              "文章",
            ],
          },
          {
            name: "宣传文案",
            id: "XCWA",
            img: "/static/images/index/article-1.png",
            children: [
              "帮我写10个在",
              {
                type: "text",
                placeholder: "[平台]",
              },
              "发布的面向",
              {
                type: "text",
                placeholder: "[人群]",
              },
              "宣传",
              {
                type: "text",
                placeholder: "[产品]",
              },
              "的营销广告文案，需要包含引人注目的标题与 100 字以内的详细内容，做成一个表格。",
            ],
          },
          {
            name: "话术",
            id: "HS",
            img: "/static/images/index/article-1.png",
            children: [
              "帮我写一段话术内容，用于",
              {
                type: "text",
                placeholder: "[使用场景]",
              },
              "。",
            ],
          },
          {
            name: "研究报告",
            id: "YJBG",
            img: "/static/images/index/article-1.png",
            children: [
              "帮我写1篇关于",
              {
                type: "text",
                placeholder: "[主题]",
              },
              "的研究报告，字数在",
              {
                type: "text",
                placeholder: "[输入数字]",
                default: "2000",
              },
              "字左右。",
            ],
          },
          {
            name: "总结汇总",
            id: "ZJHZ",
            img: "/static/images/index/article-1.png",
            children: [
              "帮我写一份用于",
              {
                type: "text",
                placeholder: "[目的：项目进展总结、团队工作成果或其他]",
              },
              "的总结汇报，需要包含",
              {
                type: "text",
                placeholder: "[工作内容]",
              },
              "和",
              {
                type: "text",
                placeholder: "[成果]",
              },
              "。",
            ],
          },
          {
            name: "小红书",
            id: "XHS",
            img: "/static/images/index/article-1.png",
            children: [
              "帮我生成一篇关于",
              {
                type: "text",
                placeholder: "[主题]",
              },
              "的小红书种草文案。文案需要包含标题和正文，需要使用多种 emoji 来增强视觉吸引力和情感表达。",
            ],
          },
          {
            name: "朋友圈",
            id: "PYQ",
            img: "/static/images/index/article-1.png",
            children: [
              "帮我生成一篇帮我生成一条关于关于",
              {
                type: "text",
                placeholder: "[主题]",
              },
              "的朋友圈。",
            ],
          },
          {
            name: "微博",
            id: "WB",
            img: "/static/images/index/article-1.png",
            children: [
              "帮我写一个关于",
              {
                type: "text",
                placeholder: "[主题]",
              },
              "的微博。",
            ],
          },
          {
            name: "计划",
            id: "JH",
            img: "/static/images/index/article-1.png",
            children: [
              "帮我制定一个",
              {
                type: "text",
                placeholder: "[计划类型]",
              },
              "，目标是",
              {
                type: "text",
                placeholder: "[例如：3个月瘦10斤]",
              },
              "。",
            ],
          },
          {
            name: "脚本",
            id: "JB",
            img: "/static/images/index/article-1.png",
            children: [
              "帮我写一个关于",
              {
                type: "text",
                placeholder: "[主题]",
              },
              "的脚本，每句话都应吸引观众的注意力，请以表格的形式输出。",
            ],
          },
          {
            name: "申请",
            id: "SQ",
            img: "/static/images/index/article-1.png",
            children: [
              "帮我写一个关于",
              {
                type: "text",
                placeholder: "[主题：例如出差]",
              },
              "的申请，理由是",
              {
                type: "text",
                placeholder: "[一句话简述原因]",
              },
              "。",
            ],
          },
          {
            name: "邮件",
            id: "YJ",
            img: "/static/images/index/article-1.png",
            children: [
              "帮我写一封关于",
              {
                type: "text",
                placeholder: "[主题]",
              },
              "的邮件，内容是",
              {
                type: "text",
                placeholder: "[一句话简述内容要求]",
              },
              "。",
            ],
          },
          {
            name: "会议纪要",
            id: "HYJY",
            img: "/static/images/index/article-1.png",
            children: [
              "帮我写一个讨论",
              {
                type: "text",
                placeholder: "[主题]",
              },
              "会议纪要。语气需要",
              {
                type: "radio",
                placeholder: "[语气]",
                checkList: [
                  {
                    label: "正式的",
                    value: "正式的",
                  },
                  {
                    label: "随意的",
                    value: "随意的",
                  },
                  {
                    label: "专业的",
                    value: "专业的",
                  },
                  {
                    label: "热情的",
                    value: "热情的",
                  },
                  {
                    label: "有信息量的",
                    value: "有信息量的",
                  },
                  {
                    label: "有趣的",
                    value: "有趣的",
                  },
                ],
              },
              "。",
            ],
          },
          {
            name: "职位描述",
            id: "ZWMS",
            img: "/static/images/index/article-1.png",
            children: [
              "帮我写一篇关于",
              {
                type: "text",
                placeholder: "[职位名称]",
              },
              "的职位描述。工作地址：",
              {
                type: "text",
                placeholder: "[指定地址]",
              },
              "公司名称：",
              {
                type: "text",
                placeholder: "[指定公司名称]",
              },
            ],
          },
        ],
      },
      {
        type: "学习/教育",
        children: [
          {
            name: "作文",
            id: "ZW", // Wen_Zhang
            img: "/static/images/index/article-2.png",
            children: [
              {
                type: "text",
                placeholder: "[在这里输入作文题目]",
              },
              "帮我根据以上题目写一篇满分作文，作文文体是",
              {
                type: "text",
                placeholder: "[输入作文体：如议论文、记叙文等]",
              },
              "，不少于",
              {
                type: "text",
                placeholder: "[输入字数]",
              },
              "字。\n",
              "写作提示：立意深远、引经据典、逻辑严密、结构完整、文采斐然、用语灵活、段落承接高级、",
              {
                type: "text",
                placeholder: "[其他补充要求]",
              },
            ],
          },
          {
            name: "论文",
            id: "LW",
            img: "/static/images/index/article-2.png",
            children: [
              "帮我写一篇关于",
              {
                type: "text",
                placeholder: "[主题]",
              },
              "的论文，字数在",
              {
                type: "text",
                placeholder: "[输入字数]",
              },
              "字左右。",
            ],
          },
          {
            name: "诗歌",
            id: "SG",
            img: "/static/images/index/article-2.png",
            children: [
              "帮我写一首关于",
              {
                type: "text",
                placeholder: "[主题]",
              },
              "的诗歌，格式是",
              {
                type: "text",
                placeholder: "[输入古诗词或者现代诗的格式]",
              },
              "。",
            ],
          },
          {
            name: "评语",
            id: "PY",
            img: "/static/images/index/article-2.png",
            children: [
              "帮我写一个",
              {
                type: "text",
                placeholder: "[输入评语类型：如电影评价]",
              },
              "，我的评价是",
              {
                type: "text",
                placeholder: "[一句话表达态度]",
              },
              "，字数在",
              {
                type: "text",
                placeholder: "[输入字数]",
                default: "100",
              },
              "字左右。",
            ],
          },
          {
            name: "教案",
            id: "JA",
            img: "/static/images/index/article-2.png",
            children: [
              "帮我写一份教案，授课对象是",
              {
                type: "text",
                placeholder: "[年龄学段]",
              },
              "，主题是",
              {
                type: "text",
                placeholder: "[课程名称]",
              },
              "。",
            ],
          },
          {
            name: "申请",
            id: "SQ",
            img: "/static/images/index/article-2.png",
            children: [
              "帮我写一个关于",
              {
                type: "text",
                placeholder: "[主题：例如出差]",
              },
              "的申请，理由是",
              {
                type: "text",
                placeholder: "[一句话简述原因]",
              },
              "。",
            ],
          },
          {
            name: "邮件",
            id: "YJ",
            img: "/static/images/index/article-2.png",
            children: [
              "帮我写一封关于",
              {
                type: "text",
                placeholder: "[主题]",
              },
              "的邮件，内容是",
              {
                type: "text",
                placeholder: "[一句话简述内容要求]",
              },
              "。",
            ],
          },
        ],
      },
      {
        type: "日常生活",
        children: [
          {
            name: "话术",
            id: "HS",
            img: "/static/images/index/article-3.png",
            children: [
              "帮我写一段话术内容，用于",
              {
                type: "text",
                placeholder: "[使用场景]",
              },
              "。",
            ],
          },
          {
            name: "小红书",
            id: "XHS",
            img: "/static/images/index/article-3.png",
            children: [
              "帮我生成一篇关于",
              {
                type: "text",
                placeholder: "[主题]",
              },
              "的小红书种草文案。文案需要包含标题和正文，需要使用多种 emoji 来增强视觉吸引力和情感表达。",
            ],
          },
          {
            name: "朋友圈",
            id: "PYQ",
            img: "/static/images/index/article-3.png",
            children: [
              "帮我生成一篇帮我生成一条关于关于",
              {
                type: "text",
                placeholder: "[主题]",
              },
              "的朋友圈。",
            ],
          },
          {
            name: "微博",
            id: "WB",
            img: "/static/images/index/article-3.png",
            children: [
              "帮我写一个关于",
              {
                type: "text",
                placeholder: "[主题]",
              },
              "的微博。",
            ],
          },
          {
            name: "评语",
            id: "PY",
            img: "/static/images/index/article-3.png",
            children: [
              "帮我写一个",
              {
                type: "text",
                placeholder: "[输入评语类型：如电影评价]",
              },
              "，我的评价是",
              {
                type: "text",
                placeholder: "[一句话表达态度]",
              },
              "，字数在",
              {
                type: "text",
                placeholder: "[输入字数]",
                default: "100",
              },
              "字左右。",
            ],
          },
          {
            name: "日记",
            id: "RJ",
            img: "/static/images/index/article-3.png",
            children: [
              "帮我写一篇关于",
              {
                type: "text",
                placeholder: "[主题]",
              },
              "的日记，不少于",
              {
                type: "text",
                placeholder: "[输入字数]",
                default: "100",
              },
              "字。",
            ],
          },
          {
            name: "邮件",
            id: "YJ",
            img: "/static/images/index/article-3.png",
            children: [
              "帮我写一封关于",
              {
                type: "text",
                placeholder: "[主题]",
              },
              "的邮件，内容是",
              {
                type: "text",
                placeholder: "[一句话简述内容要求]",
              },
              "。",
            ],
          },
          {
            name: "博客",
            id: "BK",
            img: "/static/images/index/article-3.png",
            children: [
              "帮我写一封关于",
              {
                type: "text",
                placeholder: "[主题]",
              },
              "的博客，确保体现出",
              {
                type: "text",
                placeholder: "[关键要点]",
              },
              "。文章篇幅",
              {
                type: "radio",
                placeholder: "[篇幅]",
                checkList: [
                  {
                    label: "短",
                    value: "短",
                  },
                  {
                    label: "中",
                    value: "中",
                  },
                  {
                    label: "长",
                    value: "长",
                  },
                ],
                default: "中",
              },
            ],
          },
        ],
      },
      {
        type: "商业营销",
        children: [
          {
            name: "宣传文案",
            id: "XCWA",
            img: "/static/images/index/article-4.png",
            children: [
              "帮我写10个在",
              {
                type: "text",
                placeholder: "[平台]",
              },
              "发布的面向",
              {
                type: "text",
                placeholder: "[人群]",
              },
              "宣传",
              {
                type: "text",
                placeholder: "[产品]",
              },
              "的营销广告文案，需要包含引人注目的标题与 100 字以内的详细内容，做成一个表格。",
            ],
          },
          {
            name: "文案策划",
            id: "WACH",
            img: "/static/images/index/article-4.png",
            children: [
              "帮我写一个",
              {
                type: "text",
                placeholder: "[方案类型：如线下读书会活动方案等]",
              },
              "，主题是",
              {
                type: "text",
                placeholder: "[方案内容]",
              },
              "。",
            ],
          },
          {
            name: "脚本",
            id: "JB",
            img: "/static/images/index/article-4.png",
            children: [
              "帮我写一个关于",
              {
                type: "text",
                placeholder: "[主题]",
              },
              "的脚本，每句话都应吸引观众的注意力，请以表格的形式输出。",
            ],
          },
        ],
      },
      {
        type: "文学艺术",
        children: [
          {
            name: "诗歌",
            id: "SG",
            img: "/static/images/index/article-1.png",
            children: [
              "帮我写一首关于",
              {
                type: "text",
                placeholder: "[主题]",
              },
              "的诗歌，格式是",
              {
                type: "text",
                placeholder: "[输入古诗词或者现代诗的格式]",
              },
              "。",
            ],
          },
          {
            name: "故事",
            id: "GS",
            img: "/static/images/index/article-1.png",
            children: [
              "帮我写一个关于",
              {
                type: "text",
                placeholder: "[主题]",
              },
              "的故事。确保故事引人入胜，且不超过",
              {
                type: "text",
                placeholder: "[输入字数]",
                default: "500",
              },
              "字。",
            ],
          },
          {
            name: "小说",
            id: "XS",
            img: "/static/images/index/article-1.png",
            children: [
              "帮我写一个小说，类型为",
              {
                type: "text",
                placeholder: "[例如：科幻]",
              },
              "，写作风格模仿",
              {
                type: "text",
                placeholder: "[例如：村上春树]",
              },
              "，字数",
              {
                type: "text",
                placeholder: "[输入字数]",
                default: "1000",
              },
              "左右。写作提示：层层递进、层次清晰、逻辑严密、文采斐然、表述生动形象、",
              {
                type: "text",
                placeholder: "[其他补充要求]",
              },
              "。",
            ],
          },
        ],
      },
    ],
    // questionPrefix: "帮我写作：",
  },
  {
    name: "PPT生成",
    desc: "一句话生成精美的PPT模板",
    id: "PPTG", // Jie_Ti_Yan_Yi
    user_want: USER_WANT["PPTG"],
    isUseQuotation: true,
    defaultTemplate: {
      children: [
        "帮我生成一篇关于《",
        {
          type: "text",
          placeholder: "主题",
        },
        "》的PPT。",
      ],
    },
    // model_type: "4o-plus",
    // upperBar: true,
    // lowerBar: true,
    // haveCommandBar: true,
    placeholder: "输入PPT的主题",
  },
  {
    name: "AI画图",
    desc: "按照你的想象，生成各类风格的图像",
    placeholder: "描述你所想象的画面、角色、情绪、场景、风格...",
    id: "AIHT", // AI_Hua_Tu
    user_want: USER_WANT["AIHT"],
    lowerBar: true,
    // questionPrefix: "AI画图：",
    customOptions: {
      customBtn: [
        // {
        //   id: "ruler",
        //   svgComponent: "rulerSvg",
        //   name: "比例",
        //   id: "AI画图比例",
        //   btnContent: [
        //     "比例为：",
        //     {
        //       type: "radio",
        //       placeholder: "[比例]",
        //       checkList: [
        //         {
        //           label: "16:9",
        //           value: "16:9",
        //         },
        //         {
        //           label: "9:16",
        //           value: "9:16",
        //         },
        //       ],
        //     },
        //     "，",
        //   ],
        // },
        {
          id: "style",
          svgComponent: "imgStyleSvg",
          name: "风格",
          btnContent: [
            "图片风格为",
            {
              type: "radio",
              placeholder: "[风格]",
              id: "style",
              defaultIndex: 0,
              checkList: [
                {
                  label: "水墨画",
                  value: "水墨画",
                },
                {
                  label: "彩铅画",
                  value: "彩铅画",
                },
                {
                  label: "像素风格",
                  value: "像素风格",
                },
                {
                  label: "儿童绘画",
                  value: "儿童绘画",
                },
                {
                  label: "平面插画",
                  value: "平面插画",
                },
                {
                  label: "油画",
                  value: "油画",
                },
                {
                  label: "素描",
                  value: "素描",
                },
                {
                  label: "风景画",
                  value: "风景画",
                },
                {
                  label: "人物摄影",
                  value: "人物摄影",
                },

                {
                  label: "3D",
                  value: "3D",
                },
                {
                  label: "动漫",
                  value: "动漫",
                },
              ],
            },
            "，",
          ],
        },
      ],
    },
  },

  {
    name: "阅读总结",
    desc: "速读各类文章，迅速了解摘要和任何问题",
    id: "YDZJ", // Yu_Du_Zong_Jie
    placeholder: "询问关于这篇文章的任何问题",
    user_want: USER_WANT["YDZJ"],
    upperBar: true,
    isUseQuotation: true,
    // model_type: "doubao-file",
    haveCommandBar: true,
    // questionPrefix: "阅读总结：",
  },
  {
    name: "学术搜索",
    desc: "通过对话搜索海量学术资源，保证严谨的回答体验",
    id: "XSSS", // Xue_Shu_Sou_Suo
    user_want: USER_WANT["XSSS"],
    placeholder: "搜索、提问或发消息",
    // questionPrefix: "学术搜索：",
  },
  {
    name: "在线翻译",
    desc: "帮你翻译文字内容，准确翻译不同的语言",
    id: "ZXFY", // Zai_Xian_Fan_Yi
    user_want: USER_WANT["ZXFY"],
    placeholder: "输入要翻译的文本",
    upperBar: true,
    editQuestionPrefix: "把{oriLang}内容翻译为{aimLang}：", // 有 zxfy 组件修改
    // questionPrefix: "", // 有 zxfy 组件修改
  },
  {
    name: "网页摘要",
    desc: "解读网页内容，高效地获取关键信息",
    id: "WYZY", // Wang_Ye_Zong_Yao
    placeholder: "输入要解读的网址",
    // model_type: "doubao-file",
    user_want: USER_WANT["WYZY"],
    // questionPrefix: "网页摘要：",
    defaultTemplate: {
      children: [
        "解读这个网址",
        {
          type: "text",
          placeholder: "[输入网址]",
        },
      ],
    },
    isUseQuotation: true,
    haveCommandBar: true,
    beforeSend: function (msg, inputBoxStatus, options) {
      if (!msg) return;
      const reg = new RegExp(
        "/(?:(?:https?|ftp)://)?[\\w\\-]+(\\.[\\w\\-]+)+([\\w.,@?^=%&:/~+#-]*[\\w@?^=%&/~+#-])?",
        "g"
      );
      const matchList = msg.match(reg) || [];
      console.log("matchList", matchList);
      if (matchList.length > 0) {
        const urlLink = matchList[0];
        const file = {
          url: urlLink,
          id: uuidv4(),
          status: "success",
          // name: this.urlLink.slice(0, 20) + "...",
          ext: "",
          name: urlLink,
          curCommandId: inputBoxStatus.curCommand?.id || null,
        };
        // 不需要第一时间加到里面去，会导致重复的链接的情况
        // setTimeout(() => {
        //   setQuotation(file);
        // }, 0);
        // Object.assign(inputBoxStatus.curFile, file);
      }
    },
  },
  {
    name: "图片分析",
    desc: "帮你分析图片内容，解答问题",
    id: "JTDY", // Jie_Ti_Yan_Yi
    user_want: USER_WANT["JTDY"],
    isUseQuotation: true,
    // model_type: "4o-plus",
    upperBar: true,
    lowerBar: true,
    haveCommandBar: true,
    placeholder: "输入题目，或上传题目图片",
  },
];

// INPUT_COMMAND.forEach((command) => {
//   if (command.user_want) {
//     USER_WANT[command.id] = command.user_want;
//     USER_WANT[command.name] = command.user_want;
//   }
// });
// console.log("USER_WANT", USER_WANT);

export { INPUT_COMMAND, USER_WANT };
